import { useNavigate } from 'react-router-dom'
import { DownloadIcon, ShowreelsIcon } from 'assets/icons'
import RelationContentList from 'components/RelationContentList'
import { getUser } from 'helpers/storage'
import { useCastingStore, useUserStore } from 'store'
import { Content, Relation } from 'types/app'
import { PATHS } from 'types/enums'
import { User } from 'types/user'

interface Props {
	user: User
	relations: Relation[]
	place?: 'sidebar' | 'default'
}

const Audition = ({ user, place, relations }: Props): JSX.Element => {
	const navigate = useNavigate()

	const openCasting = (
		content: Content,
		_: string | undefined,
		prodId: string | undefined,
	): void => {
		const { user } = useUserStore.getState()
		const { setCastingOverviewRedirectionLink } = useCastingStore.getState()
		setCastingOverviewRedirectionLink(
			window.location.pathname + window.location.hash,
		)
		navigate(
			`/${user?.CustomerRole?.toLowerCase()}/${PATHS.CASTING}/${prodId}/${
				content.ContentId
			}/${getUser()?.['Custom:User:Id'] || ''}`,
		)
	}

	const downloadNda = (content: Content): void => {
		const reversed = content?.assets?.reverse()
		const nda = reversed
			?.filter((a) => !a.isDeleted)
			?.find(
				(asset) =>
					asset?.uploaderUserId === user?.ContentId &&
					asset.publicUrl?.endsWith('.pdf'),
			)?.publicUrl
		const a = document.createElement('a')
		a.href = nda || ''
		a.download = 'true'
		a.target = '_blank'
		a.click()
	}

	return (
		<RelationContentList
			relations={relations}
			showUser={false}
			place={place}
			actions={[
				{
					label: 'APP_OPEN_OVERVIEW',
					icon: <ShowreelsIcon />,
					onClick: openCasting,
				},
				{
					label: 'APP_DOWNLOAD_NDA',
					icon: <DownloadIcon color="var(--mono100)" />,
					onClick: downloadNda,
				},
			]}
		/>
	)
}

export default Audition
